module.exports = __webpack_public_path__ + "static/media/lp-edu-4.7cb5850d.svg";